import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { setDocumentTitle } from "./setDocumentTitle";

type Props = {
  children?: React.ReactNode;
};

export const getFormattedDocumentTitle = (sections: string[]) => {
  return sections.join(" | ");
};

export function withTitle<T>(
  key: string[] | string,
  Component: (props?: any) => React.ReactElement | null
) {
  return (props: T & Props) => {
    const { t } = useTranslation();

    useEffect(() => {
      const getPageTitle = () => {
        if (Array.isArray(key)) {
          return key.map(k => t(k));
        }

        return [t(key)];
      };
      setDocumentTitle(getFormattedDocumentTitle(getPageTitle()));
    }, [t]);

    return (
      <>
        <Component {...props} />
      </>
    );
  };
}

withTitle.displayName = "ComponentWithTitle";
